import '../scss/main.scss';
import App from './app';

import './behaviors/status';
import './behaviors/input-time-picker';
import './behaviors/input-rut';
import './behaviors/sidebar';
import './behaviors/select-all-options';
import './behaviors/search-guide';
import './behaviors/select-manifest-duties';

import './components/DataTable';
import './components/Manifest';

import configureServer from './config/configureServer';

if (window.ENABLE_MIRAGE) {
  configureServer();
}

$(() => {
  $('.alert').each((i, item) => {
    App.utils.highlight($(item));
  });

  const $alert = $('.main-alert .alert');
  setTimeout(() => $alert.fadeOut(), 10000);

  $('.model-form input:text').addClass('form-control');

  $('select').not('.js-not-select2').select2({
    width: '100%'
  });

  $('form').submit((e) => {
    const $this = $(e.currentTarget);
    const $buttons = $this.find(':submit').not('.js-do-not-disable-on-submit');

    // disable buttons after submit to prevent disabling submit inputs
    // with values
    setTimeout(() => {
      $buttons.addClass('btn-loading').addClass('disabled').prop('disabled', true);
      App.utils.showLoading($buttons);

      window.curretSubmitTimer = setTimeout(() => {
        App.utils.hideLoadingButtons();
      }, 3000);
    }, 10);

    return true;
  });
});
